import { analyticsIdentify, analyticsLoad } from './analytics_wrapper';


export function runAnalytics (optIn) {
    // let mixpanelOptInConfig = {"track_event_name": optIn};
    // // if optIn is undefined we know the user is already opted in
    // // and we shouldn't explicitly fire an event to mixpanel
    // if (optIn === undefined) {
    //     function alreadyOptedIn() {
    //         ; // do nothing
    //     };
    //     let trackOverride = {"track": alreadyOptedIn}
    //     mixpanel.opt_in_tracking({...mixpanelOptInConfig, ...trackOverride});
    // }
    // else {
    //     mixpanel.opt_in_tracking(mixpanelOptInConfig);
    // }

    // Marketo
    (function() {
        var didInit = false;
        function initMunchkin() {
            if(didInit === false) {
            didInit = true;
            Munchkin.init('027-TSX-214');
            }
        }
        var s = document.createElement('script');
        s.type = 'text/javascript';
        s.async = true;
        s.src = '//munchkin.marketo.net/munchkin.js';
        s.onreadystatechange = function() {
            if (this.readyState == 'complete' || this.readyState == 'loaded') {
            initMunchkin();
            }
        };
        s.onload = initMunchkin;
        document.getElementsByTagName('head')[0].appendChild(s);
    })();

    // Segment
    analyticsLoad();


    // Google Analytics
    var ga_script = document.createElement("script");
    ga_script.async = true;
    ga_script.setAttribute("src", "https://www.googletagmanager.com/gtag/js?id=UA-60610307-1");
    document.head.appendChild(ga_script);

    window.dataLayer = window.dataLayer || [];
    function gtag() { dataLayer.push(arguments); }
    gtag('js', new Date());
    gtag('config', 'UA-60610307-1');

    (function(t,a,p){t.TapfiliateObject=a;t[a]=t[a]||function(){ (t[a].q=t[a].q||[]).push(arguments)}})(window,'tap');
    var tapfiliateScript = document.createElement("script");
    tapfiliateScript.setAttribute("src", "https://script.tapfiliate.com/tapfiliate.js");
    document.head.appendChild(tapfiliateScript);
    tap('create', '14279-79e523', { integration: "javascript" });
    tap('detect');

    window._6si = window._6si || [];
    window._6si.push(['enableEventTracking', true]);

    const isVisitorCompanyIdentified = window.localStorage.getItem('_6senseCompanyDetails');
    const msPerSixMonths = 1000 * 60 * 60 * 24 * 180;
    const dateIdentified = new Date(window.localStorage.getItem('_6senseDate'));
    const currentDate = new Date();
    const isGreatherThanSixMonths = currentDate - dateIdentified > msPerSixMonths;

    if (!isVisitorCompanyIdentified || isGreatherThanSixMonths) {
        window._6si.push(['enableCompanyDetails', true, (response) => {
            const responseData = JSON.parse(response);

            analyticsIdentify({
                "6sense_company":  responseData.company,
                "6sense_segments": responseData.segments,
                "6sense_scores": responseData.scores
            });
        }])

        window.localStorage.setItem('_6senseDate', currentDate.toLocaleString());

        window._6si.push(['setEpsilonKey', "04e5174c00411de193bb0b4eb1914511217ad7f4"]);
    }

    window._6si.push(['setToken', '53f94d2a02182b737669f976509fb951']);
    window._6si.push(['setEndpoint', 'b.6sc.co']);

    (function() {
    var gd = document.createElement('script');
        gd.type = 'text/javascript';
        gd.async = true;
        gd.src = '//j.6sc.co/6si.min.js';
        var s = document.getElementsByTagName('script')[0];
        s.parentNode.insertBefore(gd, s);
    })();
}
